import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const { color } = theme;

const wrap: CSSObject = {
  paddingTop: '20px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 4,
  [mobile]: {
    paddingTop: 16,
    gap: 2,
  },
};

const btn: CSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 36,
  height: 36,
  padding: '0 6px',
  borderRadius: 10,
  fontSize: 14,
  fontWeight: 500,
  color: color.grey500,
  transition: 'background-color 0.15s ease',
  ':hover:not(:disabled)': {
    background: color.grey75,
    color: color.text,
  },
  ':disabled': {
    color: color.grey200,
    cursor: 'default',
  },
};

const pageBtn = (isActive: boolean): CSSObject =>
  isActive
    ? {
        background: `${color.primary} !important`,
        color: `${color.white} !important`,
        fontWeight: 700,
      }
    : {};

const edgeBtn: CSSObject = {
  [mobile]: {
    display: 'none',
  },
};

export { wrap, btn, pageBtn, edgeBtn };
